import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

@observer
class DocumentationGridRow extends Component {

  render() {
    const { text, href } = this.props.data;
    return (
      <div className="documentation-grid-row">
        <Link className="documentation-link" title={text} to={href} onClick={(e) => {e.preventDefault();this.props.onClick(href)}}>{text}</Link>
      </div>
    );
  }
}

export default DocumentationGridRow;



// WEBPACK FOOTER //
// ./src/containers/Documentation/DocumentationGridRow.jsx